import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import { APP_TITLE } from '../../utils/constants';
import { GetString } from '../../components/StringResourceManager';
import ScheduledLogsContainer from '../../components/LogsCollection/ScheduledLogsContainer';
import { getDivisionList } from '../../store/Assets/AssetsActions';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import {
  fetchLogsFolderInfo,
  fetchUploadLogsDirectories,
} from '../../store/LogsUpload/LogsAction';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
  }),
);

export default function ScheduledLogs() {
  const classes = useStyles();

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getDivisionList(dispatch);
      fetchLogsFolderInfo(dispatch);
      fetchUploadLogsDirectories(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_SCHEDULED_LOGS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_SCHEDULED_LOGS')}
      />
      <Paper className={classes.paperGrid}>
        <ScheduledLogsContainer />
      </Paper>
    </>
  );
}
